// @ts-strict-ignore
import { useMemo } from 'react'
import { ChipProps } from '@node-space/ui-components'
import { BeneficiaryType } from 'types/beneficiaries'
import { SourcePayWallet } from '../../Pay/types'
import { PayoutBeneficiaryFilters } from '../constants'

interface BeneficiaryFormContextProps {
  wallet: SourcePayWallet
  filters: ChipProps[]
}

const useBeneficiaryFormContext = ({ filters, wallet }: BeneficiaryFormContextProps) => {
  const beneficiaryType: BeneficiaryType = useMemo(() => {
    const isFirstPartyPayoutsEnabled = filters?.find(
      filter => filter?.name === PayoutBeneficiaryFilters.MY_COMPANY
    )
    const isThirdPartyPayoutsEnabled = filters?.find(
      filter => filter?.name === PayoutBeneficiaryFilters.BUSINESS
    )

    if (isFirstPartyPayoutsEnabled && isThirdPartyPayoutsEnabled) {
      return
    }

    if (isThirdPartyPayoutsEnabled) {
      return BeneficiaryType.THIRD_PARTY
    }

    if (isFirstPartyPayoutsEnabled) {
      return BeneficiaryType.FIRST_PARTY
    }
  }, [filters])

  const isInsufficientBalance = useMemo(() => {
    if (!wallet) return false
    return wallet?.balance <= 0
  }, [wallet])

  const isPayoutsSupported = useMemo(() => {
    if (!wallet) return false
    return wallet && !!filters?.length
  }, [wallet, filters])

  const showCallout = useMemo(() => {
    if (!wallet) return false

    if (isInsufficientBalance && isPayoutsSupported) {
      return true
    }

    if (!isPayoutsSupported && !isInsufficientBalance) {
      return true
    }
  }, [wallet, isInsufficientBalance, isPayoutsSupported])

  return {
    beneficiaryType,
    isInsufficientBalance,
    isPayoutsSupported,
    showCallout,
  }
}

export default useBeneficiaryFormContext
